import { ModuleConfig } from "../../common/types";
import StorageIcon from "@mui/icons-material/Storage";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BoltIcon from "@mui/icons-material/Bolt";
import GroupIcon from "@mui/icons-material/Group";

export const config: ModuleConfig = {
  id: "myvault",
  name: "MyVault",
  description: "Use workspace applications.",
  startPage: "canvases",
  routes: [
    {
      path: "schemas",
      componentPath: "./modules/myvault/views/SchemaList",
      requiredRole: "admin",
    },
    {
      path: "views",
      componentPath: "./modules/myvault/views/ViewBrowser",
      requiredRole: "admin",
    },
    {
      path: "views/create",
      componentPath: "./modules/myvault/views/ViewBuilder",
      requiredRole: "admin",
    },
    {
      path: "views/:id/edit",
      componentPath: "./modules/myvault/views/ViewBuilder",
      requiredRole: "admin",
    },
    {
      path: "views/:id",
      componentPath: "./modules/myvault/views/ViewViewer",
      requiredRole: "admin",
    },
    {
      path: "canvases",
      componentPath: "./modules/myvault/views/CanvasBrowser",
      requiredRole: "user",
    },
    {
      path: "canvases/create",
      componentPath: "./modules/myvault/views/CanvasBuilder",
      requiredRole: "editor",
    },
    {
      path: "canvases/:id/edit",
      componentPath: "./modules/myvault/views/CanvasBuilder",
      requiredRole: "editor",
    },
    {
      path: "canvases/:id",
      componentPath: "./modules/myvault/views/CanvasApp",
      requiredRole: "user",
    },
    {
      path: "groups",
      componentPath: "./modules/myvault/views/GroupMembers",
      requiredRole: "admin",
    },
    {
      path: "automations",
      componentPath: "./modules/myvault/views/AutomationRulesList",
      requiredRole: "admin",
    },
    {
      path: "automations/new",
      componentPath: "./modules/myvault/views/AutomationRuleBuilder",
      requiredRole: "admin",
    },
    {
      path: "automations/executions",
      componentPath: "./modules/myvault/views/AutomationExecutionLog",
      requiredRole: "admin",
    },
    {
      path: "automations/:id",
      componentPath: "./modules/myvault/views/AutomationRuleBuilder",
      requiredRole: "admin",
    },
  ],
  navigation: [
    {
      path: "schemas",
      name: "Database",
      icon: StorageIcon,
      requiredRole: "admin",
    },
    {
      path: "views",
      name: "Views",
      icon: ViewModuleIcon,
      requiredRole: "admin",
    },
    {
      path: "canvases",
      name: "Apps",
      icon: DashboardIcon,
      requiredRole: "user",
    },
    {
      path: "groups",
      name: "Groups",
      icon: GroupIcon,
      requiredRole: "admin",
    },
    {
      path: "automations",
      name: "Automations",
      icon: BoltIcon,
      requiredRole: "admin",
    },
  ],
};
